import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import {DialogFooter} from '@/components/ui/dialog'

export function FormDialogFooter({
  error,
  pending,
  submitDisabled,
  submitLabel,
  onCancel,
}: {
  error: string | null
  pending: boolean
  // Submit sin sentido todavía (falta una elección), distinto de `pending`.
  submitDisabled?: boolean
  submitLabel: string
  onCancel: () => void
}) {
  const {t} = useTranslation()
  return (
    <>
      {error && <p className="text-sm text-destructive">{error}</p>}
      <DialogFooter>
        <Button type="button" variant="outline" onClick={onCancel}>
          {t('common.cancel')}
        </Button>
        <Button type="submit" disabled={pending || submitDisabled}>
          {submitLabel}
        </Button>
      </DialogFooter>
    </>
  )
}
